export enum AdType {
  Video = 'Video',
  Image = 'Image',
  ImageLandscape = 'ImageLandscape',
  VideoLandscape = 'VideoLandscape',
  ImagePortrait = 'ImagePortrait',
  VideoPortrait = 'VideoPortrait',
}
